import api from '@/lib/api';

// Module-scoped set: one entry per (tab-lifetime × archeId). Prevents
// double-counting a "Times Used" open when the user navigates in and out
// of an arche within the same browser session.
const tracked = new Set<string>();

/**
 * Fires a fire-and-forget track-open call for the given arche, deduped by
 * archeId for the lifetime of the current tab. Server-side rate limiting
 * provides a defensive second layer against rapid re-navigation.
 *
 * On failure, the archeId is removed from the dedupe set so a later attempt
 * (e.g., after a flaky network recovers) can try again.
 */
export function trackArcheOpenOnce(archeId: string): void {
  if (!archeId || tracked.has(archeId)) return;
  tracked.add(archeId);
  api.trackArcheOpen(archeId).catch(() => {
    tracked.delete(archeId);
  });
}

/**
 * {@link trackArcheOpenOnce} for one of an arche's extra Store listings — a
 * game inside it, at its own path — deduped per (arche, path) for the tab.
 */
export function trackListingOpenOnce(archeId: string, path: string): void {
  const key = `${archeId}#${path}`;
  if (!archeId || !path || tracked.has(key)) return;
  tracked.add(key);
  api.trackArcheOpen(archeId, path).catch(() => {
    tracked.delete(key);
  });
}

// Test-only reset hook
export function __resetArcheOpenTrackingForTests(): void {
  tracked.clear();
}
